import React,{useState,useEffect} from "react";
import API from "../../utils/API";
import {AvField} from "availity-reactstrap-validation";

const PixelType = ({name,value,onChange,required}) => {
    const [types,setTypes] = useState(null)

    useEffect(() => {
        API.get('/admin/pixel/types').then((response) => {
            setTypes(response.data.data)
        });
    }, [])

    return (
        <AvField
            type="select"
            name={name}
            value={value}
            onChange={onChange}
            required={required}
        >
            <option value="">Select...</option>
            {types &&
                types.map((type, index) => (
                    <option key={index} selected={value === type.id} value={type.id}>{type.title}</option>
                ))
            }
        </AvField>
    )

}

export default PixelType;
